import { useQuery } from '@tanstack/react-query';
import { AccountQueryKeys } from '@common/services/queryKeys';

import { AccountsService } from '@api/services';
import { AccountsApiAppGetIdentitiesRequest } from '@api';

export function useAppListIdentities(props?: AccountsApiAppGetIdentitiesRequest, enabled = true) {
  const { data, ...rest } = useQuery({
    queryKey: [AccountQueryKeys.AppGetIdentities, props],
    queryFn: async () => {
      const res = await AccountsService.appGetIdentities(props);
      return res;
    },
    enabled,
  });

  return {
    identities: data?.data || [],
    pagination: data?.pagination || { total: 0, limit: 10, offset: 0 },
    ...rest,
  };
}
